





















import { Vue, Component, Watch } from 'vue-property-decorator';
import { TableColumn } from '../../components/organisms/CommonTable.vue';
import { dayjs, DTW_FORMAT_JA, DT_FORMAT_JA, MONTH_FORMAT } from '../../../src_server/common/momentExtends';
import { LessonsService } from '../../biz/remote/LessonsService';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { Session } from '../../utils/Session';

@Component({ components: {} })
export default class CancelListPage extends Vue {
  private termOfDate = dayjs().add(1, 'month').date(25).format('YYYY-MM-DD');

  private rows: LessonDTO[] = [];
  private target_month: string = dayjs().format(MONTH_FORMAT);
  private cols: TableColumn[] = [
    {
      label: 'No',
      name: 'no',
      type: 'seq',
    },
    {
      label: '生徒フルネーム',
      name: 'student.full_name',
    },
    {
      label: 'クラス・イベント',
      name: 'teacher.nickname',
    },
    {
      label: '予定日',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `${dayjs(row.lessons.start_dt).format(DTW_FORMAT_JA)}`;
      },
      sortitem: 'lessons.start_dt',
      align: 'middle',
    },
    {
      label: 'キャンセル日',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `${dayjs(row.lessons.cancel_dt).format(DTW_FORMAT_JA)}`;
      },
      sortitem: 'lessons.cancel_dt',
      align: 'middle',
    },
    {
      label: 'キャンセル理由',
      name: 'lessons.cancelreason',
    },
    {
      label: 'キャンセルまでの期間',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `${row.termToCancel}日`;
      },
      sortitem: 'termToCancel',
      align: 'middle',
    },
  ];

  @Watch('target_month')
  async load() {
    const target = dayjs(this.target_month).toDate();
    const biz = new LessonsService();
    const result = await biz.getMonthlyCanceledLesson(target, Session.getSessionBuildingId());

    // キャンセルまでの期間をソートするために保持する
    this.rows = result.data.map((i: any) => {
      i.termToCancel = dayjs(i.lessons.start_dt).diff(dayjs(i.lessons.cancel_dt), 'day');
      return i;
    });
  }

  prevMonth() {
    this.target_month = dayjs(this.target_month).add(-1, 'month').format(MONTH_FORMAT);
  }
  currentMonth() {
    this.target_month = dayjs().format(MONTH_FORMAT);
  }

  async created() {
    this.load();
  }
}
